var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenditLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 33,
    viewBox: "0 0 156 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6134 6.92273L57.6782 25.7811H51.4801L43.5449 6.92273H50.3352L54.7963 17.9434L59.3758 6.92273H65.6134Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4182 21.0069V25.7811H67.8242V6.92273H83.0629V11.7368H74.0618V13.925H81.9575V18.5004H74.0618V21.0069H83.4182Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.539 6.92273V25.7811H99.3673L92.2217 17.2272V25.7811H86.1025V6.92273H91.2742L98.3804 15.4767V6.92273H104.539Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.224 6.92273C114.764 6.84316 127.081 5.45066 127.042 16.3519C127.081 27.2532 114.764 25.8607 107.224 25.7812V6.92273ZM116.185 20.8477C122.107 21.2854 122.107 11.4583 116.185 11.8959H113.54V20.8477H116.185Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.569 6.92273H129.253V25.7811H135.569V6.92273Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.307 11.8562H137.819V6.92273H155.111V11.8562H149.623V25.7811H143.307V11.8562Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L11.7251 32.4651H25.1083L13.3832 0H0Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4499 0L19.3047 11.4583L26.016 29.9984L36.8332 0H23.4499Z",
    fill: "url(#paint0_linear_24_877)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24_877",
    x1: 21.1432,
    y1: 16.3231,
    x2: 33.8304,
    y2: 11.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00557846,
    stopColor: "#FDFDFD",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0801848,
    stopColor: "#DDDDDD",
    stopOpacity: 0.1165
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182516,
    stopColor: "#C3C3C3",
    stopOpacity: 0.2361
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297059,
    stopColor: "#AFAFAF",
    stopOpacity: 0.3682
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411405,
    stopColor: "#A1A1A1",
    stopOpacity: 0.5176
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545277,
    stopColor: "#999999",
    stopOpacity: 0.6988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.111,
    height: 32.4651,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenditLogo);
export default __webpack_public_path__ + "static/media/vendit_logo.75aba857a8bd8a4732e16e98f8941780.svg";
export { ForwardRef as ReactComponent };